import { render, staticRenderFns } from "./CombinedInput.vue?vue&type=template&id=5254f0fe"
import script from "./CombinedInput.vue?vue&type=script&lang=js"
export * from "./CombinedInput.vue?vue&type=script&lang=js"
import style0 from "./CombinedInput.vue?vue&type=style&index=0&id=5254f0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports